import * as Business from '../business';
import * as Contacts from '../contacts/actions';
import * as errors   from '../util/errors';
import * as Forms    from '../components/forms';
import { compose }   from 'redux';
import { connect }   from 'react-redux';
import asFullScreen  from '../components/as_full_screen';
import Confetti      from './confetti';
import KioskModeIcon from '../assets/icons/kiosk_mode.svg';
import Navbar        from '../components/navbar';
import React         from 'react';
import Swal          from 'sweetalert2';


export class KioskModePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSaveError = this.onSaveError.bind(this);
    this.save        = this.save.bind(this);
    this.confettiRef = React.createRef();
  }

  onSaveError(error) {
    errors.showDialogError(error);
  }

  componentDidMount() {
    if (this.confettiRef)
      this.confetti = new Confetti(this.confettiRef.current);
  }

  async save(customer) {
    const onSuccess = async() => {
      this.confetti.start();
      await Swal.fire({
        text: 'Thanks, we\'ll be in touch!',
        icon: 'success'
      });
      this.confetti.stop();
    };

    const { businessID }    = this.props;
    const { provider }      = this.props;
    const { createContact } = this.props;
    await createContact({
      businessID,
      customer: {
        ...customer,
        provider:     provider.id,
        sendThankYou: true,
        source:       { name: 'member' }
      },
      provider,
      callback: onSuccess
    });
  }

  render() {
    const { businessID } = this.props;
    const { provider }   = this.props;

    return (
      <React.Fragment>
        <canvas ref={this.confettiRef} style={{ display: 'none' }} className="kiosk-mode__confetti-canvas"/>
        <Navbar title="Thank You!" backLink={`/${businessID}/contacts/add/one`}/>
        <div className="page-content">
          <StayInTouch/>
          <Forms.Form save={this.save} validate={validate} initial={{}} onSaveError={this.onSaveError}>
            <KioskModeFields/>
          </Forms.Form>
          <PrivacyNotice businessID={businessID}/>
          {provider?.name && (
            <AssistingTeamMember providerName={provider.name}/>
          )}
        </div>
      </React.Fragment>
    );
  }
}


function StayInTouch() {
  return (
    <div className="kiosk-mode-greeting">
      <h2>Let&#39;s stay in touch!</h2>
      <KioskModeIcon/>
    </div>
  );
}


function validate(fields) {
  if (!fields['contact.email.address'] && !fields['contact.phone.number'])
    throw Error('Please provide an email address and/or phone number');
}


function KioskModeFields({ ...form }) {
  return (
    <div className="kiosk-mode-form list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input
          {...form}
          name="name.full"
          type="text"
          label="Your name"
          required={true}
          autoFocus={true}
          assistType="capitalize"
          autoComplete="off"/>
        <Forms.Input
          {...form}
          name="contact.email.address"
          type="email"
          label="Your email address"
          placeholder="name@email.com"
          autoComplete="off"
          required={false}/>
        <Forms.Input
          {...form}
          name="contact.phone.number"
          type="tel"
          label="Your phone"
          placeholder="(555) 555-5555"
          autoComplete="off"
          required={false}/>
        <Forms.Button {...form} label="OK!"/>
      </ul>
    </div>
  );
}


function PrivacyNotice({ businessID }) {
  return (
    <div className="kiosk-mode-privacy-notice">
      <p>
        We don&apos;t sell contact information to 3rd parties.<br/>
        See our <a href={`/${businessID}/contacts/add/kiosk/policy`}>Privacy Policy</a>.
      </p>
      <p>You can unsubscribe at any time.</p>
    </div>
  );
}


function AssistingTeamMember({ providerName }) {
  return (
    <p className="kiosk-mode-provider">
      Today&apos;s service provided by {providerName}
    </p>
  );
}

export default connect(
  (state, { businessID }) => ({
    businessID,
    provider: Business.getCurrentProvider(state, businessID)
  }),
  dispatch => ({
    createContact: compose(dispatch, Contacts.createContact)
  })
)(asFullScreen(KioskModePage));
